export default __webpack_public_path__ + "static/media/78.a4d5ad5d.jpg";